/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import styled from "@emotion/styled";
import { Section, Col, Grid } from "./Layout";
import { List } from "./UI";
import Logo from "../assets/logo.svg";
import Pinterest from "../assets/pinterest.svg";
import Instagram from "../assets/instagram.svg";
import Facebook from "../assets/facebook.svg";
import Twitter from "../assets/twitter.svg";
import Visa from "../assets/visa.svg";
import Paypal from "../assets/paypal.svg";
import Mastercard from "../assets/mastercard.svg";
import { Link } from "react-router-dom";
import { Heading, Paragraph } from "./UI/Typoraphy";
import { Flex } from "./shared";

import { mq } from "../components/responsive";

const menus = [
  {
    heading: "Company",
    items: ["About", "Career", "Term of use", "Privacy and Cookie", "Blog"],
  },
  {
    heading: "Contact",
    items: ["Keentee: 0856073843", "info@2sjourney.com"],
  },
];

const Icon = styled.img({
  margin: "3rem 5rem 3rem 0",
  height: "3rem",
  display: "inline",
  cursor: "pointer",
});

const PaymentIcon = styled.img({
  height: "2rem",
  margin: "3rem 5rem 3rem 0",
  display: "inline",
  cursor: "pointer",

  "&:last-child": {
    marginRight: 0,
  },

  [mq.md]: {
    height: "3rem",
    marginRight: "3rem",
  },
});

const Footer = () => {
  return (
    <Section
      style={{
        backgroundColor: "#E7EDF3",
        paddingBottom: "2rem",
        zIndex: 2,

        [mq.xl]: {
          padding: "14rem 0 !important",
        },
      }}
    >
      <div
        css={{
          [mq.xl]: {
            padding: "0 30rem",
          },
        }}
      >
        <Grid>
          <Col span={{ xs: 4, md: 3 }} style={{ marginBottom: "4rem" }}>
            <img src={Logo} alt="logo" css={{ width: "16rem" }} />
          </Col>
          {menus.map((menu, i) => (
            <Col key={i} span={{ xs: 2, md: 3 }}>
              <List
                heading={{
                  content: menu.heading,
                  level: 4,
                  style: { marginBottom: "2rem" },
                }}
              >
                {menu.items.map((item, k) => (
                  <List.Item
                    style={{ lineHeight: "48px", fontSize: "16px" }}
                    key={`${(i, k)}`}
                  >
                    <Link to="/">{item}</Link>
                  </List.Item>
                ))}
              </List>
            </Col>
          ))}
          <Col
            key="social"
            span={{ xs: 4, md: 3 }}
            style={{
              margin: "6rem 0 4rem",
              [mq.md]: {
                margin: "unset",
              },
            }}
          >
            <Heading level={4}>Follow us on </Heading>
            <Flex>
              <Icon src={Facebook} alt="fb" />
              <Icon src={Instagram} alt="ig" />
              <Icon src={Twitter} alt="tw" />
              <Icon src={Pinterest} alt="pr" />
            </Flex>
          </Col>
        </Grid>
        <hr
          css={{
            [mq.md]: {
              display: "none",
              tranform: "translateX(-20px)",
              width: "100vw",
            },
          }}
        />
        <div style={{ marginTop: "1rem" }}>
          <Flex css={{ justifyContent: "space-between", alignItems: "center" }}>
            <Paragraph type="quote" style={{ color: "#939DA9" }}>
              Copyright@2020, 2SJourney
            </Paragraph>

            <Flex>
              <PaymentIcon src={Visa} alt="visa" />
              <PaymentIcon src={Paypal} alt="paypal" />
              <PaymentIcon src={Mastercard} alt="mastercard" />
            </Flex>
          </Flex>
        </div>
      </div>
    </Section>
  );
};

export default Footer;
